import React from "react"
import styled from "@emotion/styled"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Container, Flex } from "theme-ui"
import Slider from "react-slick"
import { Helmet } from "react-helmet"
import { FaChevronRight } from "@react-icons/all-files/fa/FaChevronRight"
import { FaChevronLeft } from "@react-icons/all-files/fa/FaChevronLeft"

const Wrapper = styled.div`
    position: relative;
    background-color: ${(props) => props.theme.colors.background};
    text-align: center;
    margin-bottom: 3rem;
    & h2 {
        margin-bottom: 0;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 0 2rem;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h2 {
            margin-top: 0;
        }
    }
`

const Carousel = styled.div`
    justify-content: center;
    margin: 0 auto;

    & .slick-next,
    .slick-prev {
        color: #707070;
        & :hover,
        :hover {
            color: #484848;
            display: block;
            height: 30px;
        }
    }

    & img {
        max-width: 95%;
        margin-left: 0.4rem;
    }
`

const SlickButtonNext = ({ currentSlide, slideCount, children, ...props }) => (
    <FaChevronRight {...props} />
)
const SlickButtonPrev = ({ currentSlide, slideCount, children, ...props }) => (
    <FaChevronLeft {...props} />
)

let carouselSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    nextArrow: <SlickButtonNext />,
    prevArrow: <SlickButtonPrev />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
}

function WhatsNew({ data, description }) {
    let len = data
        .map((leng) => {
            return leng.edges.length
        })
        .reduce((a, b) => a + b)

    carouselSettings.slidesToScroll = len >= 3 ? 3 : len
    carouselSettings.slidesToShow = len >= 3 ? 3 : len

    return (
        <Wrapper>
            <Container>
                <Helmet>
                    <link
                        rel="stylesheet"
                        type="text/css"
                        charset="UTF-8"
                        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                    />
                    <link
                        rel="stylesheet"
                        type="text/css"
                        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                    />
                </Helmet>
                <Flex sx={{ justifyContent: "center" }}>
                    <h2>What's New</h2>
                </Flex>
                <Flex
                    sx={{ justifyContent: "center", margin: "auto" }}
                    className="content-padding"
                >
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                </Flex>
                <Carousel>
                    <Slider {...carouselSettings}>
                        {data.map((whatsnew) =>
                            whatsnew.edges.map((item, index) => {
                                if (item.node.image === null) {
                                    return null
                                }
                                return (
                                    <GatsbyImage
                                        key={index}
                                        image={getImage(item.node.image)}
                                        alt={item.node.title}
                                    />
                                )
                            })
                        )}
                    </Slider>
                </Carousel>
            </Container>
        </Wrapper>
    )
}

export default WhatsNew
